import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material';
import { managerComponentStyles } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/components/styles.ts';
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import { tasksPageText } from '~/modules/tasks/constants.ts';
import { tasksPageStyles } from '~/modules/tasks/styles.ts';
import { useState } from 'react';
import { styles } from '~/modules/identification/forms/BusinessRelations/styles.ts';
import { BaseModal } from '~/components/modals/BaseModal/BaseModal.tsx';
import { APPLICATION_STATUS, nonReturnableStatuses } from '~/constants/directoryList.ts';

interface IActionsButtonProps {
  onArchive?: () => void;
  onVerification?: () => void;
  onRestore?: () => void;
  status: string;
}

export const ActionsButton = ({
  onArchive,
  onVerification,
  onRestore,
  status,
}: IActionsButtonProps) => {
  const [action, setAction] = useState<HTMLElement | null>(null);
  const [isModalVerification, setIsModalVerification] = useState(false);
  const isOpen = Boolean(action);

  const returnApplication = !nonReturnableStatuses.includes(status);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => setAction(event.currentTarget);
  const handleClose = () => setAction(null);

  const handleArchive = () => {
    handleClose();
    onArchive?.();
  };

  const handleModalVerification = () => setIsModalVerification(true);

  const handleVerification = (action: boolean) => {
    if (action) {
      onVerification?.();
    }
    handleClose();
    setIsModalVerification(false);
  };

  const handleRestore = () => {
    handleClose();
    onRestore?.();
  };

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        endIcon={<KeyboardArrowDownIcon fontSize="small" />}
        onClick={handleOpen}
        sx={managerComponentStyles.tableActionBtn}
        aria-controls={isOpen ? `task-actions-menu` : undefined}
        aria-haspopup="true"
        aria-expanded={isOpen ? 'true' : undefined}
      >
        {tasksPageText.actionButton}
      </Button>
      <Menu
        anchorEl={action}
        open={isOpen}
        onClose={handleClose}
        keepMounted
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        slotProps={{
          paper: {
            sx: tasksPageStyles.taskActionsMenuPaper,
          },
        }}
      >
        {status !== APPLICATION_STATUS.MOVED_TO_ARCHIVE && (
          <MenuItem onClick={handleArchive} sx={tasksPageStyles.taskActionsMenuItem}>
            Видалити заявку
          </MenuItem>
        )}
        {returnApplication && (
          <MenuItem onClick={handleRestore} sx={tasksPageStyles.taskActionsMenuItem}>
            Повернути заявку
          </MenuItem>
        )}
        {status !== APPLICATION_STATUS.MOVED_TO_ARCHIVE && (
          <MenuItem onClick={handleModalVerification} sx={tasksPageStyles.taskActionsMenuItem}>
            Видалити верифікацію
          </MenuItem>
        )}
      </Menu>

      <BaseModal
        open={isModalVerification}
        onClose={() => handleVerification(false)}
        containerProps={{ sx: styles.clarifyingModalContainer }}
      >
        <Typography variant="h4">Підтвердження видалення верифікації керівника</Typography>
        <Typography variant="body1">
          Ви впевнені, що бажаєте видалити поточну верифікацію керівника?
        </Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button variant="outlined" onClick={() => handleVerification(true)}>
            Видалити
          </Button>
          <Button variant="outlined" onClick={() => handleVerification(false)}>
            Скасувати
          </Button>
        </Box>
      </BaseModal>
    </>
  );
};
